var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"final-winner"},[_c('div',{staticClass:"final-winner__title"},[_vm._v("Победитель")]),_c('div',{staticClass:"final-winner__value"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }